/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcAssetsV1AssetEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_ASSETS_V1_ASSET_EVENT_ENTITY_NAME = 'ixc.assets.v1.AssetEvent';
export const ixcAssetsV1AssetEventEntity = new schema.Entity<IxcAssetsV1AssetEvent>(IXC_ASSETS_V1_ASSET_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcAssetsV1AssetEvent) => `${entity.metadata?.eventId}` });

